export default "__VITE_ASSET__ae0215b2__"